module.exports = __webpack_public_path__ + "99bcc1d7d64452384621f3713ef9c7e5.svg";